import { DARK_COMPOUND } from './dark-tokens';

/**
 * Hover grammar — the house interaction recipe for every landing primitive
 * (R4-P2 build brief §1.5, derived from dossier §4.1-4.5, attio/raycast/
 * spline/linear/diabrowser consensus). Exported as plain className constants
 * rather than a globals.css class — keeps this phase's existing-file
 * footprint to the single sanctioned `landing-motion.ts` edit (brief §0).
 *
 * Rule 1 — asymmetric snap-in / ease-out: entering hover reads instant
 * (50ms), leaving reads calm (300ms). `duration-50` is NOT in Tailwind's
 * default scale, so the "in" leg uses the arbitrary `duration-[50ms]`.
 * Rule 2 — hover promotes exactly ONE rung on the surface ladder (R6 warm
 * retint, 2026-07-17: `#161410 -> #1B1815`, `DARK_SURFACE.base` ->
 * `DARK_SURFACE.raised` in `ui/dark-tokens.ts` — was `#121418 -> #16191E`
 * pre-R6), never a new hue. Sourced from `DARK_COMPOUND.hoverSurfaceRaisedBg`
 * (not a re-typed literal) so the resting fill and hover target stay one
 * rung apart on the SAME warm ladder — never a warm-rest/cool-hover split.
 * Rule 4 — card lift = fill-in + 4px rise, 200ms, no scale/rotate, and is
 * PRM-gated per primitive (motion-reduce: variants neutralize the transform).
 */

/** Promote one rung on the surface ladder; colors only, asymmetric 50ms in / 300ms out. */
export const HOVER_SURFACE = `transition-colors duration-300 ease-in-out hover:duration-[50ms] ${DARK_COMPOUND.hoverSurfaceRaisedBg}`;

/** Card lift: fill-in + 4px rise, 200ms, no scale. PRM-safe. */
export const HOVER_LIFT =
  `transition-[transform,background-color] duration-200 ease-out hover:-translate-y-1 ${DARK_COMPOUND.hoverSurfaceRaisedBg} ` +
  'motion-reduce:transition-none motion-reduce:hover:translate-y-0 motion-reduce:hover:transform-none';

/** Press acknowledgement; rides the micro easing. Compose with the above. */
export const PRESS = 'active:scale-[.97]';
